import {
    PageAndSort,
    AlreadyInterceptionAfterSaleResult,
    WaitInterceptionAfterSaleResult,
    WaitInterceptionOrderQueryParam1,
    AlreadyInterceptionOrderQueryParam,
    LogisticsInterceptParam,
    SuccessFailResult,
    LogisticsInterceptionStatisticsUsingGetParams,
    LogisticsInterceptionQuickSearchResult,
    LogisticsInterceptResult,
    LogisticsInterceptionStatusResult
} from '@servicesTypings/towerAftersaleRequest'
import { towerAftersaleRequest } from '@/utils/request'

// 查询标记已拦截列表
/**
 * 查询标记已拦截列表
 */
export function alreadyInterceptionOrder(data: PageAndSort): API.Res<AlreadyInterceptionAfterSaleResult[]> {
    return towerAftersaleRequest.post('/logisticsInterceptions/interceptionInitiated', { data })
}

// 查询待拦截的单子
/**
 * 查询待拦截列表
 */
export function waitInterception(data: PageAndSort): API.Res<WaitInterceptionAfterSaleResult[]> {
    return towerAftersaleRequest.post('/logisticsInterceptions/waitLogisticsInterception', { data })
}

// 查询待拦截的单子数量
/**
 * 查询待拦截列表count
 */
export function waitInterceptionCountApi(data: WaitInterceptionOrderQueryParam1): API.Res<number> {
    return towerAftersaleRequest.post('/logisticsInterceptions/waitLogisticsInterceptionCount', { data })
}

// 查询已拦截的单子数量
/**
 * 查询标记已拦截列表count
 */
export function alreadyInterceptionOrderCountApi(data: AlreadyInterceptionOrderQueryParam): API.Res<number> {
    return towerAftersaleRequest.post('/logisticsInterceptions/interceptionInitiatedCount', { data })
}

// 标记已拦截
/**
 * 申请标记拦截
 */
export function finishLogistics(data: LogisticsInterceptParam[]): API.Res<SuccessFailResult> {
    return towerAftersaleRequest.post('/logisticsInterceptions/applyInterception', { data })
}

// 取消标记已拦截
/**
 * 取消标记已拦截
 */
export function unmarkInterceptedApi(data: string[]): API.Res<SuccessFailResult> {
    return towerAftersaleRequest.post('/logisticsInterceptions/unmarkIntercepted', { data })
}

// 取消标注拦截成功
/**
 * 取消标记已拦截
 */
export function unmarkInterceptionSuccessApi(data: string[]): API.Res<SuccessFailResult> {
    return towerAftersaleRequest.post('/logisticsInterceptions/unmarkInterceptionSuccess', { data })
}

// 申请标记拦截成功
/**
 * 申请标记拦截成功
 */
export function interceptionSuccessApi(data: LogisticsInterceptParam[]): API.Res<SuccessFailResult> {
    return towerAftersaleRequest.post('/logisticsInterceptions/interceptionSuccess', { data })
}

// 物流拦截统计
/**
 * 物流拦截统计
 */
export function logisticsInterceptionStatisticsApi(
    params: LogisticsInterceptionStatisticsUsingGetParams
): API.Res<LogisticsInterceptionQuickSearchResult[]> {
    return towerAftersaleRequest.get('/logisticsInterceptions/logisticsInterceptionStatistics', { params })
}

// 复制或导出快递单号
/**
 * 复制或导出快递单号
 */
export function copyAndExportLidApi(data: LogisticsInterceptParam[]): API.Res<LogisticsInterceptResult[]> {
    return towerAftersaleRequest.post('/logisticsInterceptions/copyAndExportLid', { data })
}

// 查询列表拦截状态
/**
 * 查询列表拦截状态
 */
export function logisticsInterceptionStatusApi(data: string[]): API.Res<LogisticsInterceptionStatusResult[]> {
    return towerAftersaleRequest.post('/logisticsInterceptions/logisticsInterceptionStatus', { data })
}
